import Text from '$tablet-app/src/app/components/Text';
import useRecordImage from '$tablet-app/src/app/images/hooks/useRecordImage';
import { Meal } from '$tablet-app/src/app/models';
import MealTypeChip from '$tablet-app/src/app/recipes/components/MealTypeChip';
import { recipe_thumbnail_image_edits } from '$tablet-app/src/app/recipes/data/image_params';
import { useGetRecipe } from '@akin-home/recipes/react';
import { spacing } from '@akin-home/theme';
import React, { FC } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import styled from 'styled-components/native';
import { ItemStyling } from './types';

interface Props {
  item: Meal;
  styling: ItemStyling;
}

/** Item to be displayed in the breakdown schedule */
const MealScheduleItemContent: FC<Props> = (props) => {
  const { item, styling } = props;

  const id = item.recipes[0]?.id;

  const { data: recipe } = useGetRecipe({ id });

  const { uri } = useRecordImage({
    record: recipe,
    edits: recipe_thumbnail_image_edits,
  });

  const mealPrepTime = recipe?.prepTime?.label;

  return (
    <View style={styles.container}>
      <View style={styling.imageContainerStyle}>
        {uri ? <RecipeImage size={styling.emojiSize} source={{ uri }} /> : null}
      </View>

      <View style={[styles.contentContainer, styling.contentContainerStyle]}>
        <View style={styles.textContainer}>
          <Text
            variant={styling.titleTextVariant}
            weight="semibold"
            numberOfLines={2}
            style={[styles.titleText, styling.titleTextStyle]}
          >
            {item.title}
          </Text>

          <Text variant={styling.subtitleTextVariant}>{mealPrepTime}</Text>
        </View>

        <View style={styles.mealChipContainer}>
          <MealChip mealType={item.mealType} />
        </View>
      </View>
    </View>
  );
};

const RecipeImage = styled(Image)<{ size?: number }>`
  aspect-ratio: 1;
  width: ${({ size = 66 }) => size}px;

  border-radius: 20px;
`;

const MealChip = styled(MealTypeChip)`
  height: 25px;

  padding: 2px 8px;
`;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[4],
  },
  contentContainer: {
    flex: 1,
    gap: spacing[2],
  },
  textContainer: {
    flex: 1,
  },
  titleText: {
    overflow: 'hidden',
  },
  mealChipContainer: {
    alignSelf: 'flex-start',
  },
});

export default MealScheduleItemContent;
